
<!-- the map -->
<fourd-map-view-component #mapComp></fourd-map-view-component>


    <!-- Poor mans toolbar -->
    <div class="topbar" style="top:10px;left:10px;width:97%;" [ngClass]="{disabled:loading}">
    
        <select #proj (change)="jumpTo(['../../..',proj.value,'auto',tab])">
            <option *ngFor="let p of projects" [value]="p.id" [selected]="p == project">{{p.name}}</option>
        </select> \ 
        <select #scenez (change)="jumpTo(['../..',scenez.value,tab])">
            <option *ngFor="let p of scenes" [value]="p.id" [selected]="p == scene">{{p.name}}</option>
        </select> 
        <span class="float-right">
            <a [ngClass]="{yellow:tab == 'scenes'}" [routerLink]="['../scenes']">Scenes ({{ scenes?.length }})</a> | 
            <a [ngClass]="{yellow:tab == 'layers'}" [routerLink]="['../layers']">Layer ({{sceneLayers?.length}})</a> | 
            <a [ngClass]="{yellow:tab == 'annots'}" [routerLink]="['../annots']">Annots ({{annotations?.length}})</a> | 
            <a [ngClass]="{yellow:tab == 'photos'}" [routerLink]="['../photos']">Photos ({{scenePhotos?.length}})</a> |
            <a [ngClass]="{yellow:tab == 'processing'}" [routerLink]="['../processing']">Processing</a> |
            
    
        </span>

    </div>
    
    <div class="float-box" *ngIf="loading">
        <h4 translate>GENERIC.LOADING</h4>
    </div>
    <!-- Scene list -->
    <div class="float-box" *ngIf="project && scene && tab == 'scenes'">
        <h4>Scenes</h4>
        <div *ngFor="let curScene of scenes">
            <a routerLinkActive="yellow" [routerLink]="['../../',curScene.id,tab]">{{ curScene.name }}</a>
        </div>
    
    </div>

<!-- Layers list -->
    <div class="float-box" *ngIf="tab == 'layers' && scene">
        
        <h4>Layers</h4>
        <div *ngFor="let curLayer of sceneLayers">
            <input type="checkbox" [checked]="checked[''+ curLayer.id]" (change)="toggleLayer(curLayer,$event)"/> 
            <a routerLinkActive="yellow" [routerLink]="['layer', curLayer.id,'jump','true']">
                {{ curLayer.name }}
            </a>
        </div>
    </div>

    <div class="float-bottom-box" *ngIf="tab == 'layers' && sceneFolder">
        <div>
            <a routerLinkActive="yellow" class="float-right" [routerLink]="['upload']">UPLOAD</a>
            <h4>Files</h4>
        </div>
        <tree-view [selectedFolder]="senceFolderSelected" [rootLevelStore]="sceneFolderStore"></tree-view>    
    </div>

<!-- Annotations list -->
    <div class="float-box" *ngIf="tab == 'annots' && scene">
        <h4>Annotations</h4>
        <div *ngFor="let a of annotations">
            <input type="checkbox" [checked]="checkedAnnot[''+ a.id]" (change)="toggleAnnot(a,$event)"/> 
        
                <a routerLinkActive="yellow" [routerLink]="['annot', a.id,'jump','true' ]">{{ a.name }}</a>
        
        </div>
    </div>
    
<!-- Photos list -->
    <div class="float-box" *ngIf="tab == 'photos' && scene">
        <h4>Photos</h4>
    
        <div *ngFor="let a of scenePhotos">
            <a routerLinkActive="yellow" [routerLink]="['photo', a.id ,'jump','true']">{{ a.name }}</a>
        </div>
    </div>

<!-- Jobs list -->
<div class="float-box" *ngIf="tab == 'processing' && scene">
    <h4>Processing</h4>
    <tree-view [selectedFolder]="selectedJob" [rootLevelStore]="jobTypes"></tree-view>    
</div>

<!-- Details view, hide when nothing showing -->
    <div class="float-box-right" *ngIf="route.firstChild">
        <router-outlet></router-outlet>
    </div>

<!-- My quick n dirty cursor attempt -->
    <div class="context-box" 
    *ngIf="contextCursor?.coodinate && !cameraMoving && mapComp?.screenOffset" 
    [style.top]="(mapComp.screenOffset.y + contextCursor?.coodinate?.screenPosition.y) + 'px'" 
    [style.left]="(mapComp.screenOffset.x + contextCursor?.coodinate?.screenPosition.x) + 'px'">
        Hello {{ contextCursor?.meta?.feature ? contextCursor?.meta?.feature.name :'Click!'}}
        <div>Height {{ contextCursor?.coodinate.height }}</div>
    </div>
